import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=6baf87b2&scoped=true&"
import script from "./Videos.vue?vue&type=script&lang=js&"
export * from "./Videos.vue?vue&type=script&lang=js&"
import style0 from "./Videos.vue?vue&type=style&index=0&id=6baf87b2&lang=scss&scoped=true&"
import style1 from "./Videos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf87b2",
  null
  
)

export default component.exports